var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuzoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    viewBox: "0 0 74.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222 690 c-82 -41 -134 -106 -163 -202 -19 -61 -20 -77 -10 -126 20 -99 72 -176 154 -228 50 -32 150 -57 196 -49 130 22 212 80 263 182 29 59 33 77 32 143 -1 120 -58 216 -163 278 -40 23 -59 27 -146 30 -96 3 -103 2 -163 -28z m174 -136 c40 -19 74 -63 83 -108 7 -30 9 -31 64 -34 57 -3 57 -3 51 -30 -15 -63 -55 -112 -107 -131 -91 -35 -205 25 -223 118 -6 30 -8 31 -60 31 -53 0 -54 1 -54 29 0 36 36 89 79 118 41 28 117 31 167 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 438 l-23 -23 54 -3 c63 -4 70 1 46 28 -24 26 -50 25 -77 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 392 c0 -34 73 -44 90 -12 10 19 8 20 -40 20 -27 0 -50 -4 -50 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuzoa);
export default __webpack_public_path__ + "static/media/nuzoa.7fc13a5ddd7a3381fcbcc11b54f96c5c.svg";
export { ForwardRef as ReactComponent };